import {
  ContentIsland,
  Grid,
  LocalizedError,
  Skeleton,
  Stack,
  Typography,
} from '@razz-team/ui-web';

export function ThreeDSLoading() {
  return (
    <Stack width="100%" spacing={2}>
      <Skeleton variant="rounded" width="100%" height={293} />
      <Skeleton variant="rounded" width="100%" height={188} />
      <Stack direction={{ xs: 'column-reverse', sm: 'row' }} spacing={2} width="100%">
        <Skeleton variant="rounded" width="100%" height={56} />
        <Skeleton variant="rounded" width="100%" height={56} />
      </Stack>
    </Stack>
  );
}

export function ThreeDSError({ error }: { error: Error }) {
  return (
    <ContentIsland>
      <Grid container spacing={2} justifyContent="center" padding={4}>
        <Typography variant="body1" color="error.main">
          <LocalizedError error={error} />
        </Typography>
      </Grid>
    </ContentIsland>
  );
}
